import { render, staticRenderFns } from "./local-sample-types-modal.vue?vue&type=template&id=799298e2&scoped=true&"
import script from "./local-sample-types-modal.ts?vue&type=script&lang=ts&"
export * from "./local-sample-types-modal.ts?vue&type=script&lang=ts&"
import style0 from "./local-sample-types-modal.scss?vue&type=style&index=0&id=799298e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799298e2",
  null
  
)

export default component.exports